import { type FC } from 'react'

import { useCartIntermediateContext } from '../../hooks/useCartIntermediateContext'
import { CartIntermediateProductInfo } from '../CartIntermediateProductInfo/CartIntermediateProductInfo'

import styles from './CartIntermediateProductWithButtonsSection.module.css'

export const CartIntermediateProductWithButtonsSectionContent: FC = () => {
  const { entries } = useCartIntermediateContext()
  const [mainProduct, recommendedProduct] = entries ?? []
  const hasRecommendedProduct = Boolean(recommendedProduct)

  return (
    <>
      <div className={styles['product-main']}>
        <CartIntermediateProductInfo entry={mainProduct} />
      </div>

      {hasRecommendedProduct ? (
        <div className={styles['product-recommended']}>
          <CartIntermediateProductInfo entry={recommendedProduct} />
        </div>
      ) : null}
    </>
  )
}
